<div class="row">
  <div class="col-xs-12">
    <div ng-hide="gleba.tem_kml">Não tem coordenadas</div>
    <div id="{{idMapContentGleba}}" class="h-500" ng-show="gleba.tem_kml"></div>
  </div>
</div>